import { useQueries, useQuery } from "react-query";
import { useParams } from "react-router-dom";
import {
  getCarouselClicksEmbedAnalytics,
  getCarouselClicksViewsEmbedAnalytics,
  getCarouselViewsEmbed,
  getMyLinksEmbedAnalytics,
  getPageEmbedAnalytics,
  getPageViewsEmbed,
  getPostClicksEmbedAnalytics,
  getPostClicksViewsEmbedAnalytics,
  getPostEmbedAnalytics,
  getSocialLinksEmbedAnalytics,
  getUniqueEmbedUsers,
  getUserViewsEmbedAnalytics,
} from "../../../../Utils/SupabaseServices/EmbedAnalyticsDatabase";

function useGraphicalEmbedPageAnalytics(
  user_id: any,
  startDate: any,
  endDate: any,
  isYesterday: any,
  daysNumber: any
) {
  const { username } = useParams();
  //Based on usernames

  const { data: pageAnalytics, isLoading: loadingPageAnalytics } = useQuery(
    [`overview-page-embed-analytics`, username, startDate],
    () => {
      return getPageEmbedAnalytics(
        username,
        startDate,
        endDate,
        user_id,
        isYesterday,
        daysNumber
      );
    },
    { refetchOnWindowFocus: true }
  );

  const { data: userViewAnalytics, isLoading: loadingUserViewsAnalytics } =
    useQuery(
      [`overview-user-views-embed-analytics`, username, startDate],
      () => {
        return getUserViewsEmbedAnalytics(
          username,
          startDate,
          endDate,
          user_id,
          isYesterday,
          daysNumber
        );
      },
      { refetchOnWindowFocus: true }
    );
  const { data: postAnalytics, isLoading: loadingPostAnalytics } = useQuery(
    [`overview-post-embed-analytics`, username, startDate],
    () => {
      return getPostEmbedAnalytics(
        username,
        startDate,
        endDate,
        user_id,
        isYesterday,
        daysNumber
      );
    },
    { refetchOnWindowFocus: true }
  );

  const { data: socialLinksAnalytics, isLoading: loadingSocialLinksAnalytics } =
    useQuery(
      [`overview-socialLinks-embed-analytics`, username, startDate],
      () => {
        return getSocialLinksEmbedAnalytics(
          username,
          startDate,
          endDate,
          user_id,
          isYesterday,
          daysNumber
        );
      },
      { refetchOnWindowFocus: true }
    );

  const { data: myLinksAnalytics, isLoading: loadingMyLinksAnalytics } =
    useQuery(
      [`overview-myLinks-embed-analytics`, username, startDate],
      () => {
        return getMyLinksEmbedAnalytics(
          username,
          startDate,
          endDate,
          user_id,
          isYesterday,
          daysNumber
        );
      },
      { refetchOnWindowFocus: true }
    );

  const { data: postClicksAnalytics, isLoading: loadingPostClicksAnalytics } =
    useQuery(
      [`overview-postClicks-embed-analytics`, username, startDate],
      () => {
        return getPostClicksEmbedAnalytics(
          username,
          startDate,
          endDate,
          user_id,
          isYesterday,
          daysNumber
        );
      },
      { refetchOnWindowFocus: true }
    );
  const {
    data: carouselClicksAnalytics,
    isLoading: loadingCarouselClicksAnalytics,
  } = useQuery(
    [`overview-carouselClicks-embed-analytics`, username, startDate],
    () => {
      return getCarouselClicksEmbedAnalytics(
        username,
        startDate,
        endDate,
        user_id,
        isYesterday,
        daysNumber
      );
    },
    { refetchOnWindowFocus: true }
  );
  const {
    data: postClicksViewsAnalytics,
    isLoading: loadingPostClicksViewsAnalytics,
  } = useQuery(
    [`overview-postClicksViews-embed-analytics`, username, startDate],
    () => {
      return getPostClicksViewsEmbedAnalytics(
        username,
        startDate,
        endDate,
        user_id,
        isYesterday,
        daysNumber
      );
    },
    { refetchOnWindowFocus: true }
  );
  const {
    data: carouselClicksViewsAnalytics,
    isLoading: loadingCarouselClicksViewsAnalytics,
  } = useQuery(
    [`overview-carouselClicksViews-embed-analytics`, username, startDate],
    () => {
      return getCarouselClicksViewsEmbedAnalytics(
        username,
        startDate,
        endDate,
        user_id,
        isYesterday,
        daysNumber
      );
    },
    { refetchOnWindowFocus: true }
  );

  const { data: uniqueUsers, isLoading: loadingUniqueUsers } = useQuery(
    ["overview-unique-embed-users", username, startDate],
    () => {
      return getUniqueEmbedUsers(username, startDate, endDate, user_id);
    },
    { refetchOnWindowFocus: true }
  );
  const { data: pageViews, isLoading: loadingPageViews } = useQuery(
    [`overview-page-views-embed`, username, startDate],
    () => {
      return getPageViewsEmbed(username, startDate, endDate, user_id);
    },
    { refetchOnWindowFocus: true }
  );

  const { data: carouselViews, isLoading: loadingCarouselViews } = useQuery(
    [`overview-carousel-views-embed`, username, startDate],
    () => {
      return getCarouselViewsEmbed(username, startDate, endDate, user_id);
    },
    { refetchOnWindowFocus: true }
  );
  return {
    loadingPageAnalytics,
    pageAnalytics,
    loadingPostAnalytics,
    postAnalytics,
    socialLinksAnalytics,
    loadingSocialLinksAnalytics,
    uniqueUsers,
    loadingUniqueUsers,
    pageViews,
    loadingPageViews,
    carouselViews,
    loadingCarouselViews,
    myLinksAnalytics,
    loadingMyLinksAnalytics,
    postClicksAnalytics,
    loadingPostClicksAnalytics,
    carouselClicksAnalytics,
    loadingCarouselClicksAnalytics,
    loadingUserViewsAnalytics,
    userViewAnalytics,
    postClicksViewsAnalytics,
    loadingPostClicksViewsAnalytics,
    carouselClicksViewsAnalytics,
    loadingCarouselClicksViewsAnalytics,
  };
}

export default useGraphicalEmbedPageAnalytics;
